import { AbstractPmsApiService } from "./abstract.service";
import { AdditionalPaymentOption } from "../models";

/**
 * @class AdditionalPaymentOptionPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<AdditionalPaymentOption>}
 */
export class AdditionalPaymentOptionPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/additional-payment-option(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {AdditionalPaymentOption}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new AdditionalPaymentOption(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<AdditionalPaymentOption>>}
     */
    get (params = {}, property = null) {
        
        const url = this.url({propertyId: property ? property.id : 0});
        
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {AdditionalPaymentOption} additionalPaymentOption
     * @returns {Promise.<AdditionalPaymentOption>}
     */
    create(additionalPaymentOption) {
        
        const url = this.url({propertyId: additionalPaymentOption.property.id});
        
        return this.http
                   .post(url, additionalPaymentOption.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {AdditionalPaymentOption} additionalPaymentOption
     * @returns {Promise.<AdditionalPaymentOption>}
     */
    update(additionalPaymentOption) {
        
        const url = this.url({
            propertyId: additionalPaymentOption.property.id,
            id:         additionalPaymentOption.id
        });
        
        return this.http
                   .put(url, additionalPaymentOption.toObjectExcept('property'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {AdditionalPaymentOption} additionalPaymentOption
     * @returns {Promise.<boolean>}
     */
    delete(additionalPaymentOption) {
        
        const url = this.url({
            propertyId: additionalPaymentOption.property.id,
            id:         additionalPaymentOption.id
        });
        
        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
    
    used(property) {
        
        const url = this.url({propertyId: property ? property.id : 0});
        
        return this.http
                   .get(url + '/used', {
                       headers: this.authHeaders
                   })
                   .then(this.getMassModeler())
                   .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/additional-payment-option.service.js